// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"28a27c40","89":"529e7573","375":"da6a8610","542":"6100a1df","787":"91bd498a","811":"e2edb4a8","886":"d5186df0","891":"35c75295"}[chunkId] + ".chunk.js";
};